import { Box, ListItem, styled } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export const Root = styled('div')(({ theme }) => ({
    // height: '100%',
    backgroundColor:
        theme.palette.mode === 'light' ? grey[100] : theme.palette.background.default,
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
    color: '#fff',
    cursor: 'pointer',
    width: 'auto',
    padding: 0,
    margin: '0 1rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    transition: 'all .2s ease-in-out',
    '&:hover': {
        scale: 1.3,
    }
}));